import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('industrie', 'diagnostic-cee')!;

export default function IndustrieDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/industrie"
        backLabel="Espace industrie"
        duration="60 sec"
      >
        <DiagnosticFunnel lockedAudience="industrie" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace industrie', url: 'https://solutionecofrance.fr/industrie' },
          { name: 'Diagnostic CEE industriel', url: 'https://solutionecofrance.fr/industrie/diagnostic-cee' },
        ]}
      />
    </>
  );
}
